export const SET_LOAD_NOTICIES_STATE = 'SET_LOAD_NOTICIES_STATE';

export default function setLoadNoticies(payload) {
  return {
    type: SET_LOAD_NOTICIES_STATE,
    payload,
  };
}
